export enum StatusEnum {
  OFFEN = "Offen",
  WARTE_AUF_NUTZERANGABEN = "Warte auf Nutzerangaben",
  WARTE = "Warte",
  BEARBEITUNG_UNS = "Bearbeitung durch Uns",
  ZAHLUNGSAUFFORDERUNG = "Zahlungsaufforderung",
  MAHNUNG = "Mahnung",
  WIDERRUFEN = "Widerrufen",
  ABGESCHLOSSEN = "Abgeschlossen",
  GERICHT = "Gericht",
  INKASSO = "Inkasso",
}
